import React, { useState } from 'react';
import cx from 'classnames';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { FontAwesomeIcon, VideoClipIcon } from '@magoosh/lib/icons';
import VideoPlayer, { VideoPlayerProps } from '@magoosh/organisms/video_player/template';

import ActivityCard from '../card';
import { Activity } from '../types';

import style from './style.module.scss';

interface Props {
  nextActivity: Activity;
  onVideoFinished?: () => void;
  video: VideoPlayerProps;
  videoTitle: string;
}

const VideoActivity: React.FC<Props> = (props) => {
  const [isFinished, setIsFinished] = useState(false);

  const handleVideoFinished = () => {
    setIsFinished(true);

    props.onVideoFinished && props.onVideoFinished();
  };

  const handleVideoRestarted = () => {
    setIsFinished(false);
  };

  if (isFinished && props.nextActivity) {
    return (
      <div
        className={cx(
          style.activityContainer,
          'align-items-center d-flex flex-column justify-content-center'
        )}
      >
        <div className={style.finishedNextActivity}>
          <ActivityCard activity={props.nextActivity} detailed next />
        </div>

        <div className={style.finishedRewatchVideo}>
          <div
            className="bg-white border-radius-all d-flex flex-column gap-m u-padding-A-s"
            style={{ border: '1px dashed #B5B1BB' }}
          >
            <div className="d-flex gap-m">
              <div className="align-items-center d-flex gap-s">
                <VideoClipIcon />
                <div className="hidden-xs"><strong>{props.videoTitle}</strong></div>
                <div className="visible-xs"><strong>Video</strong></div>
              </div>

              <div className="d-flex flex-1 justify-content-end">
                <DefaultFilledButton onClick={handleVideoRestarted} size="sm">
                  Rewatch
                </DefaultFilledButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <VideoPlayer {...props.video} onEnd={handleVideoFinished} />
    );
  }
};

export default VideoActivity;
